/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const SlugIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="SlugIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              d="M10.933 3.91983L8.866 7.50001H13V8.50001H8.86605L10.933 12.0801L10.067 12.5801L8 8.99996L5.93301 12.5801L5.06699 12.0801L7.13395 8.50001H3V7.50001H7.134L5.06699 3.91983L5.93301 3.41983L8 6.99996L10.067 3.41983L10.933 3.91983Z"
              fill="currentColor"
            />
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

SlugIcon.tags = [
  'star',
  'asterisk',
  'symbol',
  'note',
  'url',
  'punctuation',
  'mark',
  'character',
  'wildcard',
];

SlugIcon.category = 'General Icons';

SlugIcon.iconSize = 16;
